var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon @2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6666667,6.73333333 L14.6666667,7.33333333 C14.6666667,11.4 11.4,14.6666667 7.33333333,14.6666667 C7.33333333,14.6666667 7.33333333,14.6666667 7.33333333,14.6666667 C3.26666667,14.6666667 0,11.4 0,7.33333333 C0,3.26666667 3.26666667,0 7.33333333,0 C7.33333333,0 7.33333333,0 7.33333333,0 C8.33333333,0 9.4,0.2 10.3333333,0.666666667 C10.6666667,0.8 10.8,1.2 10.6666667,1.53333333 C10.5333333,1.86666667 10.1333333,2 9.8,1.86666667 C9,1.53333333 8.2,1.33333333 7.33333333,1.33333333 C7.33333333,1.33333333 7.33333333,1.33333333 7.33333333,1.33333333 C4,1.33333333 1.33333333,4 1.33333333,7.33333333 C1.33333333,10.6666667 4,13.3333333 7.33333333,13.3333333 C7.33333333,13.3333333 7.33333333,13.3333333 7.33333333,13.3333333 C10.6666667,13.3333333 13.3333333,10.6666667 13.3333333,7.33333333 L13.3333333,6.73333333 C13.3333333,6.33333333 13.6,6.06666667 14,6.06666667 C14.4,6.06666667 14.6666667,6.33333333 14.6666667,6.73333333 Z M15.1333333,0.866666667 C14.8666667,0.6 14.4666667,0.6 14.2,0.866666667 L7.33333333,7.73333333 L5.8,6.2 C5.53333333,5.93333333 5.13333333,5.93333333 4.86666667,6.2 C4.6,6.46666667 4.6,6.86666667 4.86666667,7.13333333 L6.86666667,9.13333333 C7,9.26666667 7.2,9.33333333 7.33333333,9.33333333 C7.46666667,9.33333333 7.66666667,9.26666667 7.8,9.13333333 L15.1333333,1.8 C15.4,1.53333333 15.4,1.13333333 15.1333333,0.866666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Onboarding-screen-1",
    transform: "translate(-455.000000, -200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-Menu-/-Modulr-/-LC",
    transform: "translate(163.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-",
    transform: "translate(292.666667, 12.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#003056",
    xlinkHref: "#path-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.9c945b8f5f6c25fef0dc913293894d5e.svg";
export { ForwardRef as ReactComponent };